import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PopularCoursesRoutingModule} from './popular-courses-routing.module';
import {PopularCoursesComponent} from './popular-courses.component';
import {AddPopularCoursesComponent} from './add-popular-courses/add-popular-courses.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {PopularCourseInfoComponent} from './popular-course-info/popular-course-info.component';
import {QuillModule} from 'ngx-quill';
import {EditorModule} from '@tinymce/tinymce-angular';
import {ImageCropperModule} from 'ngx-image-cropper';
import {SharedModule} from '../../shared/shared.module';
import { PopularCoursesMarketingTagComponent } from './popular-courses-marketing-tag/popular-courses-marketing-tag.component';
import { AddPopularCoursesMarketingTagComponent } from './popular-courses-marketing-tag/add-popular-courses-marketing-tag/add-popular-courses-marketing-tag.component';
import {PopularCourseDetailShellComponent} from './popular-course-detail-shell/popular-course-detail-shell.component';
import {PopularCourseOverviewComponent} from './popular-course-overview/popular-course-overview.component';
import {PopularCourseEligibilityDurationComponent} from './popular-course-eligibility-duration/popular-course-eligibility-duration.component';
import {PopularCourseFeeStructureComponent} from './popular-course-fee-structure/popular-course-fee-structure.component';
import {PopularCourseTopUniversitiesComponent} from './popular-course-top-universities/popular-course-top-universities.component';
import {PopularCourseSubjectSyllabusComponent} from './popular-course-subject-syllabus/popular-course-subject-syllabus.component';
import {PopularCourseFaqComponent} from './popular-course-faq/popular-course-faq.component';
import {PopularCourseAdmissionProcessComponent} from './popular-course-admission-process/popular-course-admission-process.component';
import {PopularCourseBenefitsComponent} from './popular-course-benefits/popular-course-benefits.component';
import {PopularCourseCareerComponent} from './popular-course-career/popular-course-career.component';
import {PopularCourseWhyUsComponent} from './popular-course-why-us/popular-course-why-us.component';


@NgModule({
    declarations: [PopularCoursesComponent, AddPopularCoursesComponent, PopularCourseInfoComponent, PopularCoursesMarketingTagComponent, AddPopularCoursesMarketingTagComponent,
        PopularCourseDetailShellComponent, PopularCourseOverviewComponent, PopularCourseEligibilityDurationComponent, PopularCourseFeeStructureComponent, PopularCourseTopUniversitiesComponent, PopularCourseSubjectSyllabusComponent, PopularCourseFaqComponent,
        PopularCourseAdmissionProcessComponent, PopularCourseBenefitsComponent, PopularCourseCareerComponent, PopularCourseWhyUsComponent],
    imports: [
        CommonModule,
        PopularCoursesRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule,
        QuillModule,
        EditorModule,
        ImageCropperModule,
        SharedModule
    ],
    exports: [PopularCoursesComponent, AddPopularCoursesComponent, PopularCourseInfoComponent]
})

export class PopularCoursesModule {
}
